import { EnhancedRouteProps } from '../../../../routes/Enhanced/Enhanced.route';
import Business from '../Business/pages/Business/pages/Business';
import UrgentCampaigns from './pages/UrgentCampaigns';

export default [
  {
    path: '',
    element: UrgentCampaigns,
  },
  {
    path: ':urlFilter',
    element: UrgentCampaigns,
  },
  {
    path: ':listingCategory/:listingSlug',
    element: Business,
  },
] as Array<EnhancedRouteProps>;
